// Exclusively here for PhantomJS, and maybe some IE... ideally replace to reduce
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';

import App from 'components/templates/app';
import registerServiceWorker from 'registerServiceWorker';

import 'index.css';

import { configureStore, history } from 'data/store/configureStore';

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js